import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// Import components
import Header from './components/Header';
import HomePage from './pages/Home';
import ActiveTradesPage from './pages/ActiveTrades';
import RiskManagementPage from './pages/RiskManagement';
import SetupsPage from './pages/Setups';
import LoginPage from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';

// Import services
import { initAuth, verifyToken } from './services/auth';

function App() {
  const [initializing, setInitializing] = useState(true);
  
  // Initialize authentication on app load
  useEffect(() => {
    const initialize = async () => {
      const hasToken = initAuth();
      
      if (hasToken) {
        // Verify token is still valid
        try {
          await verifyToken();
        } catch (error) {
          console.error('Token verification failed:', error);
        }
      }
      
      setInitializing(false);
    };
    
    initialize();
  }, []);
  
  if (initializing) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }
  
  return (
    <Router>
      <div className="App">
        <Header />
        <main className="container mt-4">
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <HomePage />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/active-trades"
              element={
                <ProtectedRoute>
                  <ActiveTradesPage />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/risk-management"
              element={
                <ProtectedRoute>
                  <RiskManagementPage />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/setups"
              element={
                <ProtectedRoute>
                  <SetupsPage />
                </ProtectedRoute>
              }
            />

            {/* Redirect any unknown routes to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <footer className="footer mt-auto py-3 bg-light">
          <div className="container text-center">
            <span className="text-muted">Signal Monkey &copy; {new Date().getFullYear()}</span>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;